export default __webpack_public_path__ + "images/dc84e7ff5595f766daf61d0727792a43.png";